import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import NearbyAreas from './NearbyAreas';
import AreaDedicatedArticle from '../AreaDedicatedArticle';
import AreaRelatedArticles from '../AreaRelatedArticles';

const MidTierTemplate = ({ areaData, displayName, phone, brand, images }) => {
  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
      {/* Header Section */}
      <header id="header" className="area-hero-header" style={{
        background: '#fff',
        color: '#333',
        borderRadius: '1.5rem',
        padding: '3rem 2rem',
        marginBottom: '2rem',
        textAlign: 'center',
        border: '1px solid #ddd',
        boxShadow: '0 5px 15px rgba(0,0,0,0.05)',
        marginTop: '2rem',
        position: 'relative'
      }}>
        <nav aria-label="الرجوع إلى قائمة المناطق">
          <Link to="/areas" style={{
            position: 'absolute', top: '1rem', left: '1rem', color: '#0077ff',
            textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.5rem',
            fontSize: '0.95rem', fontWeight: 600
          }}>
            <ArrowLeft size={18} /> المناطق
          </Link>
        </nav>
        <nav aria-label="مسار التنقل" style={{ fontSize: '0.95rem', marginBottom: '1rem', opacity: 0.95, direction: 'rtl', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
          <Link to="/" style={{ color: '#0077ff', textDecoration: 'none', fontWeight: 700 }}>الرئيسية</Link>
          <span style={{ color: '#94a3b8' }}>/</span>
          <Link to="/areas" style={{ color: '#0077ff', textDecoration: 'none', fontWeight: 700 }}>مناطق الخدمة</Link>
          <span style={{ color: '#94a3b8' }}>/</span>
          <span style={{ color: '#0a2c61', fontWeight: 800 }}>ونش انقاذ {displayName}</span>
        </nav>
        <h1 style={{ fontSize: '2.2rem', fontWeight: 800, marginBottom: '1rem', color: '#0a2c61', direction: 'rtl' }}>
          ونش انقاذ {displayName} | خصم 50%
        </h1>
        <div style={{ background: '#e3f0ff', color: '#0077ff', padding: '0.5rem 1rem', borderRadius: '1rem', display: 'inline-block', marginBottom: '1rem', fontWeight: 'bold' }}>
          متاح الآن بالقرب منك - وقت الوصول المقدر: {areaData.responseTime}
        </div>
        <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '0 auto', direction: 'rtl', lineHeight: 1.8 }}>
          {areaData.intro}
        </p>
      </header>

      {/* Main Content & Coverage */}
      <section id="local-coverage" aria-labelledby="coverage-heading" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', marginBottom: '2rem' }}>
        <article style={{ background: 'white', borderRadius: '1.5rem', padding: '2rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', border: '1px solid #eee', direction: 'rtl' }}>
          <h2 id="coverage-heading" style={{ color: '#0077ff', fontSize: '1.4rem', marginBottom: '1rem' }}>نتواجد دائماً بالقرب من:</h2>
          <ul style={{ lineHeight: 1.8 }}>
            {areaData.landmarks.map((lm, i) => <li key={i}>{lm}</li>)}
            {areaData.streets.map((st, i) => <li key={i}>{st}</li>)}
          </ul>
        </article>
        <article style={{ background: 'white', borderRadius: '1.5rem', padding: '2rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', border: '1px solid #eee', direction: 'rtl' }}>
          <h3 style={{ color: '#0077ff', fontSize: '1.4rem', marginBottom: '1rem' }}>مميزات الإنقاذ لدينا:</h3>
          <ul style={{ lineHeight: 1.8 }}>
            <li>أوناش صغيرة الحجم قادرة على دخول الشوارع الضيقة.</li>
            <li>أوناش شوكة خاصة بسحب السيارات من الجراجات.</li>
            <li>أسعار واضحة تماماً وتنافسية جداً داخل {displayName}.</li>
            <li>دفع بالفيزا أو كاش أو المحافظ الإلكترونية.</li>
          </ul>
        </article>
      </section>

      {/* Dedicated Supporting Article Section */}
      <AreaDedicatedArticle
        areaData={areaData}
        displayName={displayName}
        templateType="MidTier"
        phone={phone}
      />

      {/* Related Supporting Articles & Pillar Guides */}
      <AreaRelatedArticles areaName={displayName} />

      {/* FAQ */}
      {areaData.faqs && areaData.faqs.length > 0 && (
        <section id="faq" aria-labelledby="faq-heading" style={{ background: 'white', borderRadius: '1.5rem', padding: '2rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem', border: '1px solid #eee', direction: 'rtl' }}>
          <h2 id="faq-heading" style={{ fontSize: '1.5rem', fontWeight: 800, color: '#0a2c61', marginBottom: '1.5rem', textAlign: 'center' }}>أسئلة شائعة</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {areaData.faqs.map((faq, index) => (
              <article key={index} style={{ borderBottom: '1px solid #eee', paddingBottom: '1rem' }}>
                <h3 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#0077ff', marginBottom: '0.5rem' }}>{faq.q}</h3>
                <p style={{ margin: 0, color: '#555', lineHeight: 1.6 }}>{faq.a}</p>
              </article>
            ))}
          </div>
        </section>
      )}

      {/* Nearby Areas — Internal Linking */}
      <NearbyAreas nearby={areaData.nearby} accentColor="#0077ff" />
    </div>
  );
};
export default MidTierTemplate;
